/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Traffic / bid status labels used on lists and targeting pickers.
 */
import {NgModule} from '@angular/core';

import {AppSharedModule} from '../app-shared.module';
import {AdStatusLabelComponent} from '../../ad-unit/ad-status-component';
import {AdvertiserStatusLabelComponent} from '../../advertiser/advertiser-status-component';

const RESOURCE_STATUS = [
  AdStatusLabelComponent,
  AdvertiserStatusLabelComponent
];

@NgModule({
  imports: [AppSharedModule],
  declarations: RESOURCE_STATUS,
  exports: RESOURCE_STATUS
})
export class ResourceStatusModule {
}
